import { render, staticRenderFns } from "./notFoundComponent.vue?vue&type=template&id=16c912b6&scoped=true&"
import script from "./notFoundComponent.vue?vue&type=script&lang=js&"
export * from "./notFoundComponent.vue?vue&type=script&lang=js&"
import style0 from "./notFoundComponent.vue?vue&type=style&index=0&id=16c912b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c912b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VContainer})
